import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ClientModel, ClientWalkInModel,TestingTrailModel, FollowUpStatus, BrandModel, BrandmodelModel, EmployeeModel, BranchModel, FamilyModel, ReferenceModel } from '../model/index';

@Injectable()
export class CommonService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9'});
    private comboUrl = 'api/combo';
    private commonUrl = 'api/common';
    private reportUrl = 'api/reports';
    private printUrl = 'api/print';
    private pocUrl = 'api/poc';
    private exportUrl = 'api/exportReports';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getUserMenus(param=''): Promise<any> {
        const url = `${this.commonUrl}/getUserMenuList?userId=`+param;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getStateList(): Promise<any> {
    const url = `${this.commonUrl}/getStatesList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    } 
    getDistrictList(): Promise<any> {
    const url = `${this.commonUrl}/getDistrictsList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getUserList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getFollowerName`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getCampPromoUsers(): Promise<any> {
        const url = `${this.comboUrl}/getCampPromoUsers`;
        return this.http.get(url, { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getHVUserList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getHVUserName`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getHVTechnicianList(): Promise<any> {
        const url = `${this.comboUrl}/getHVTechnicianList`;
        return this.http.get(url, { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getAccUserList({}): Promise<any> {
        const url = `${this.commonUrl}/getAccUserList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getNotificationList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getNotificationList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getCurrentNotification(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getCurrentNotification`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    removeNotification(params: any): Promise<any> {
        const url = `${this.commonUrl}/removeNotification`;
        return this.http
            .post(url, $.param(params), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    printing(printData: any): Promise<any> {
        const url = `${this.printUrl}/ExportExcel`;
        return this.http
            .post(url, $.param(printData), { headers: this.headers,  responseType: ResponseContentType.ArrayBuffer })
            .toPromise()
            .then(res => res)
    }
        getSampleFiles(params: any): Promise<any> {
        const url = `${this.commonUrl}/getSampleFiles`;
        return this.http
            .get(url + '?' + $.param(params), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(err => [JSON.parse(err._body)]);
    }

    downloadSampleFile(params: any): Promise<any> {
        const url = `${this.commonUrl}/downloadSampleFile`;
        return this.http
            .post(url, $.param(params), { headers: this.headers, responseType: ResponseContentType.ArrayBuffer })
            .toPromise()
            .then(res => res)
            .catch(err => err);
    }
    // loadClientList(term: string): Promise<any> {
    //
    //     const url = `${this.comboUrl}/clientList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(err => [JSON.parse(err._body)]);
    // }
    loadClientList(term: string, type: string): Observable<ClientWalkInModel[]> {
        return this.http
            .get(`${this.comboUrl}/clientList?name=${term}&type=${type}`)
            .map(response => response.json().data as ClientWalkInModel[]);
    }
    loadTestClientList(term: string, type: string, date: string): Observable<ClientWalkInModel[]> {
        return this.http
            .get(`${this.comboUrl}/testClientList?name=${term}&type=${type}&date=${date}`)
            .map(response => response.json().data as ClientWalkInModel[]);
    }

    loadClientCashReceiptList(term: string, type: string): Observable<ClientWalkInModel[]> {
        return this.http
            .get(`${this.comboUrl}/clientCashReceiptList?name=${term}&type=${type}`)
            .map(response => response.json().data as ClientWalkInModel[]);
    }

    loadClientGridList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/clientList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    search(terms: Observable<string>, gridParams: any) {
        return terms.debounceTime(400)
            .distinctUntilChanged()
            .switchMap(term => this.searchEntries(term, gridParams));
    }
    searchEntries(term, gridParams) {
        //http://localhost:4200/api/clientWalkIn/getWalkInList?start=0&limit=25&orderColumn=date&orderDir=asc&filter=%7B%22search_data%22:%22%22%7D
        const url = `${this.commonUrl}/clientSearchGridList`;
        const queryUrl = '?search=' + term + '&start=' + gridParams['offset'] + '&limit=' + gridParams['limit'] + '&orderColumn=' + gridParams['orderBy'] + '&orderDir=' + gridParams['orderDir'] + '&title=' + gridParams['type'];
        //let gridParam = json_encode(gridParams);
        return this.http
            .get(url + queryUrl)
            .map(res => res.json());
    }
    getFollowUpStatusList(query: any): Observable<FollowUpStatus[]> {
        let params: URLSearchParams = new URLSearchParams();
            for (let key in query) {
                params.set(key.toString(), query[key]);
            }

            let options = new RequestOptions({
                headers: this.headers,
                search: params
            });
        const url = `${this.comboUrl}/followUpStatusList`;
        return this.http.get(url, options)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }
    // getFollowUpStatusList(query: any): Promise<any> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     for (let key in query) {
    //         params.set(key.toString(), query[key]);
    //     }
    //
    //     let options = new RequestOptions({
    //         headers: this.headers,
    //         search: params
    //     });
    //
    //     const url = `${this.comboUrl}/followUpStatusList`;
    //     return this.http.get(url, options)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(err => [JSON.parse(err._body)]);
    // }

    getClientHistory(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getClientHistory`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getClientHistoryDetails(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getClientHistoryDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getTrackHistory(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getServiceTrackingDetailReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getReferenceList(): Observable<ReferenceModel[]> {
        // const url = `${this.comboUrl}/getReferenceList`;
        // return this.http.get(url)
        //     .toPromise()
        //     .then(this.extractData)
        //     .catch(err => [JSON.parse(err._body)]);

            const url = `${this.comboUrl}/getReferenceList`;
        return this.http.get(url)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }

    // getBrandList(): Promise<any> { 
    //     const url = `${this.comboUrl}/getBrandList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(err => [JSON.parse(err._body)]);
    // }

    getBrandList(): Observable<BrandModel[]> {
        const url = `${this.comboUrl}/getBrandList`;
        return this.http.get(url)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }

    getBrandModelList(): Observable<BrandmodelModel[]> {
        const url = `${this.comboUrl}/getBrandModelList`;
        return this.http.get(url)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }
    getAutoNumber(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getAutoNumber`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getTestingtypeList(): Promise<any> {

        const url = `${this.comboUrl}/getTestingtypeList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getStoreUserList(): Promise<any> {

        const url = `${this.comboUrl}/getStoreUserList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getComplaintList(): Promise<any> {

        const url = `${this.comboUrl}/getComplaintList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    // getEmployeeList(): Promise<any> {
    //     const url = `${this.comboUrl}/getChallanEmpList`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(err => [JSON.parse(err._body)]);
    // }
    getEmployeeList(term: string, type: string): Observable<EmployeeModel[]> {
        return this.http
            .get(`${this.comboUrl}/getEmployeeList?name=${term}&type=${type}`)
            .map(response => response.json().data as EmployeeModel[]);
    }
    getAvailableEmployeeList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getAvailableEmployeeList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getHaModelStock(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getHaModelStock`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

     getHaModelTrailStock(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getHaModelTrailStock`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getEmployeeName(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getEmployeeName`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

     getSourceName(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getSourceName`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getBankLedger(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getBankLedger`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getNoAdvance(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getNoAdvance`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

   

    getChallanOutNoList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getChallanOutNoList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getBranchList(): Observable<BranchModel[]> {
        const url = `${this.comboUrl}/getBranchList`;
        return this.http.get(url)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }
    getSingleClientDetails(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getSingleClientDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getTcNoList(): Promise<any> {
        const url = `${this.comboUrl}/getTcNos`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
     getServiceNoList(): Promise<any> {
        const url = `${this.comboUrl}/getServiceNoList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getStockModelList(pageData: any): Promise<any> {
        // let params: URLSearchParams = new URLSearchParams();
        // for (let key in query) {
        //     params.set(key.toString(), query[key]);
        // }

        // let options = new RequestOptions({
        //     headers: this.headers,
        //     search: params
        // });

        const url = `${this.comboUrl}/stockModelList`;
        return this.http.post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getPurchasePartyList(): Promise<any> {
        const url = `${this.comboUrl}/getPurchasePartyList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getPartyList(): Promise<any> {
        const url = `${this.comboUrl}/getPartyList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getSrfList(): Promise<any> {
        const url = `${this.comboUrl}/getSrfList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getAreaCityList(): Promise<any> {
        const url = `${this.comboUrl}/getAreaCityList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getLedgerList(params: any): Promise<any> {
        const url = `${this.comboUrl}/getLedgerList`;
        return this.http.post(url, $.param(params), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getServiceModel(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getServiceModel`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    loadClientSerGridList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/clientServiceList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    servicesearch(terms: Observable<string>, gridParams: any) {
        return terms.debounceTime(400)
            .distinctUntilChanged()
            .switchMap(term => this.serviceSearchEntries(term, gridParams));
    }
    serviceSearchEntries(term, gridParams) {
        const url = `${this.commonUrl}/clientServiceSearchGridList`;
        const queryUrl = '?search=' + term + '&start=' + gridParams['offset'] + '&limit=' + gridParams['limit'] + '&orderColumn=' + gridParams['orderBy'] + '&orderDir=' + gridParams['orderDir'] + '&title=' + gridParams['type'];

        return this.http
            .get(url + queryUrl)
            .map(res => res.json());
    }
    purchasesearch(terms: Observable<string>, gridParams: any) {
        return terms.debounceTime(400)
            .distinctUntilChanged()
            .switchMap(term => this.purchaseSearchEntries(term, gridParams));
    }
    purchaseSearchEntries(term, gridParams) {

          const url = `${this.commonUrl}/purchaseServiceSearchGridList`;
          const queryUrl = '?search=' + term + '&start=' + gridParams['offset'] + '&limit=' + gridParams['limit'] + '&orderColumn=' + gridParams['orderBy'] + '&orderDir=' + gridParams['orderDir'];

          return this.http
            .get(url + queryUrl)
            .map(res => res.json());
    }
    advancesearch(terms: Observable<string>, gridParams: any) {
        return terms.debounceTime(400)
            .distinctUntilChanged()
            .switchMap(term => this.advanceSearchEntries(term, gridParams));
    }
    advanceSearchEntries(term, gridParams) {
        const url = `${this.commonUrl}/clientAdvanceSearchGridList`;
        const queryUrl = '?search=' + term + '&start=' + gridParams['offset'] + '&limit=' + gridParams['limit'] + '&orderColumn=' + gridParams['orderBy'] + '&orderDir=' + gridParams['orderDir'];

        return this.http
            .get(url + queryUrl)
            .map(res => res.json());
    }
    getSalesDetails(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getSalesDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    } 
    getTrailDetails(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getTrailDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    
    getFamilyList(): Promise<FamilyModel[]> {
        const url = `${this.comboUrl}/getFamilyList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)])
    }

    getMenuMappingUserList(): Promise<any> {
    const url = `${this.commonUrl}/getMenuMappingUserList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    } 

    saveMenuMapping(param: any): Promise<any> {
        const url = `${this.commonUrl}/saveMenuMapping`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getReferenceTypeList(): Observable<any> {
        const url = `${this.comboUrl}/referenceTypeList`;
        return this.http.get(url)
            .map(res => res.json())
            .catch(err => [JSON.parse(err._body)])
    }

    exportExcelMulti(data:any): Promise<any> {
        const url = `${this.printUrl}/ExportExcelMulti`;
        return this.http
        .post(url, $.param(data), { headers: this.headers, responseType: ResponseContentType.ArrayBuffer })
        .toPromise()
        .then(res => res)
    }

    exportDynamicExcel(data:any): Promise<any> {
        const url = `${this.printUrl}/exportDynamicExcel`;
        return this.http
        .post(url, $.param(data), { headers: this.headers, responseType: ResponseContentType.ArrayBuffer })
        .toPromise()
        .then(res => res)
    }

    getFileList(query: any): Promise<TestingTrailModel[]> {  
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getFileList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    addPhoto(rowData: any): Promise<TestingTrailModel[]> {
        const url = `${this.commonUrl}/addPhoto`; 
        var formData = new FormData();
        formData.append('files',rowData.files);
        formData.append('client_id',rowData.client_id);
           return this.http
            .post(url, formData)
            .toPromise()
            .then(res => res.json() as  Promise<TestingTrailModel[]>)     
    }
    deleteDocument(file_id: any): Promise<TestingTrailModel> {
        const url = `${this.commonUrl}/deleteDocument`;
        return this.http
            .post(url, $.param({ file_id: file_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
    }

    billDiscountApprovalList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/billDiscountApprovalList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getDiscountApprovalList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getDiscountApprovalList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    saveUpdateDiscountApproval(param: any): Promise<any> {
        const url = `${this.commonUrl}/saveUpdateDiscountApproval`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    changeDiscountStatus(param: any): Promise<any> {
        const url = `${this.commonUrl}/changeDiscountStatus`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    deleteVoucherAmount(param: any): Promise<any> {
        const url = `${this.commonUrl}/deleteVoucherAmount`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    AddVoucherToDayBook(param: any): Promise<any> {
        const url = `${this.commonUrl}/AddVoucherToDayBook`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    updateVoucherDetails(param: any): Promise<any> {
        const url = `${this.commonUrl}/updateVoucherDetails`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    deleteCustomerEntries(param: any): Promise<any> {
        const url = `${this.commonUrl}/deleteCustomerEntries`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    ////////////////new add///////////////////////////////
    updateClientWalkDate(param: any): Promise<any> {
        const url = `${this.commonUrl}/updateClientWalkDate`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getPocListByPov(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.pocUrl}/pocListByPov`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    UpdateStockDet(param: any): Promise<any> {
        const url = `${this.commonUrl}/UpdateStockDet`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    deleteClientWalkinEntry(param: any): Promise<any> {
        const url = `${this.commonUrl}/deleteClientWalkinEntry`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    updateClientWalkinTestingEntry(param: any): Promise<any> {
        const url = `${this.commonUrl}/updateClientWalkinTestingEntry`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    // loadReferenceList(term: string): Observable<ReferenceModel[]> {
    //     return this.http
    //         .get(`${this.comboUrl}/searchreferenceList?name=${term}`)
    //         .map(response => response.json().data as ReferenceModel[]);
    // }
    loadReferenceList(): Promise<any> {
        const url = `${this.comboUrl}/searchreferenceList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getAllList(): Promise<any> {
        const url = `${this.commonUrl}/getAllList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getHsnCodeList(): Promise<any> {
        const url = `${this.comboUrl}/getHSNCodeList`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getExistServiceClient(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getExistServiceClient`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getTestingTypeDet(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getTestingTypeDet`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    deleteClientFollowHistory(param: any): Promise<any> {
        const url = `${this.commonUrl}/deleteClientFollowHistory`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    updateModelSerial(param: any): Promise<any> {
        const url = `${this.commonUrl}/updateModelSerial`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    
    getHaModelStockHisUpd(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getHaModelStockHisUpd`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getModelHistory(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getModelHistory`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getFollowupStatusList(): Promise<any> {
        const url = `${this.comboUrl}/getFollowupStatusList`;
        return this.http.get(url, { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getClientFollowupDetails(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getClientFollowupDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    updateFollowupStatus(param: any): Promise<any> {
        const url = `${this.commonUrl}/updateFollowupStatus`;
        return this.http.post(url, $.param(param), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    uploadFollowupChangeExcel(formData: FormData): Promise<any> {
        const headers = new Headers({ 'Accept': 'application/json' });
        const url = `${this.commonUrl}/uploadFollowupChangeExcel`;
        return this.http.post(url, formData, { headers: headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    processBulkFollowupChange(data: any): Promise<any> {
        const url = `${this.commonUrl}/processBulkFollowupChange`;
        return this.http.post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    processFollowupChange(data: any): Promise<any> {
        const url = `${this.commonUrl}/processFollowupChange`;
        return this.http.post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    downloadSampleExcel(fileName: string, sampleData: any[]): Promise<any> {
        const url = `${this.commonUrl}/downloadSampleExcel`;
        const params = { fileName: fileName, sampleData: JSON.stringify(sampleData) };
        return this.http.post(url, $.param(params), {
            headers: this.headers,
            responseType: ResponseContentType.Blob
        })
            .toPromise()
            .then((response) => {
                const blob = new Blob([response.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName + '.xlsx';
                link.click();
                window.URL.revokeObjectURL(url);
                return { success: true };
            })
            .catch(err => [JSON.parse(err._body)]);
    }

    getSerialNumberList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getSerialNumberList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getClientMobileNo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/getClientMobileNo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    // Branch Daily Report Folder Methods
    getBranchFolders(): Promise<any> {
        const url = `${this.exportUrl}/getFolders`;
        return this.http.get(url)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getBranchFolderFiles(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.exportUrl}/getFilesFromFolder`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getBranchFolderStats(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.exportUrl}/getFolderStats`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    downloadBranchFile(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            responseType: ResponseContentType.ArrayBuffer
        });

        const url = `${this.exportUrl}/downloadFile`;
        return this.http.post(url, params.toString(), options)
            .toPromise()
            .catch(err => [JSON.parse(err._body)]);
    }

    cronExportDsr(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        return this.http.get('api/dsr/cronExport', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    runAllReports(): Promise<any> {
        return this.http.get('api/dsrConvertReports/runAll', new RequestOptions({ headers: this.headers }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    getRunAllStatus(run_id: string): Promise<any> {
        const params = new URLSearchParams();
        params.set('run_id', run_id);
        return this.http.get('api/dsrConvertReports/runAllStatus', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    runSingleReport(key: string): Promise<any> {
        const params = new URLSearchParams();
        params.set('key', key);
        return this.http.get('api/dsrConvertReports/runSingle', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    getSingleRunStatus(run_id: string): Promise<any> {
        const params = new URLSearchParams();
        params.set('run_id', run_id);
        return this.http.get('api/dsrConvertReports/runAllStatus', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    sendReportMail(data: any): Promise<any> {
        const postHeaders = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
        return this.http.post('api/dsr/sendReportMail', $.param(data), { headers: postHeaders })
            .toPromise()
            .then(res => res.json())
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    getReportMailsByReport(report_name: string): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('report_name', report_name);
        return this.http.get('api/reportMailConfig/mailsByReport', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    getEmployeeEmailList(query: any = {}): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        return this.http.get('api/employeeEmailConfig/list', new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(err => ({ success: false, message: err.message || 'Error' }));
    }

    searchClientByNo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/searchClientByNo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    searchFollowupStatus(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.commonUrl}/searchFollowupStatus`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getDsrInputFiles(): Promise<any> {
        const url = 'api/dsrInputFiles/getFiles';
        return this.http.get(url, { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    downloadDsrInputFile(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params,
            responseType: ResponseContentType.ArrayBuffer
        });

        const url = 'api/dsrInputFiles/downloadFile';
        return this.http.get(url, options)
            .toPromise()
            .catch(err => [JSON.parse(err._body)]);
    }

    uploadReplaceDsrInputFile(formData: FormData): Promise<any> {
        const headers = new Headers({ 'Accept': 'application/json' });
        const url = 'api/dsrInputFiles/replaceFile';
        return this.http.post(url, formData, { headers: headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    uploadAddDsrInputFile(formData: FormData): Promise<any> {
        const headers = new Headers({ 'Accept': 'application/json' });
        const url = 'api/dsrInputFiles/addFile';
        return this.http.post(url, formData, { headers: headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    deleteDsrInputFile(body: any): Promise<any> {
        const url = 'api/dsrInputFiles/deleteFile';
        return this.http.post(url, $.param(body), { headers: this.headers })
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

    getEzCrmCallLogDetail(id: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('id', id);
        let options = new RequestOptions({ headers: this.headers, search: params });
        const url = 'api/ezCrm/getCallLogDetail';
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/common.service.ts